import { Injector } from '@angular/core';
import { combineLatest, of } from 'rxjs';
import { map, distinctUntilChanged } from 'rxjs/operators';
import { MenuStructure } from '@nimbus-library/features/menu/models/menu-structure.model';
import { MenuViewModel } from '@nimbus-library/features/menu/models/menu.view-model';
import { MenuFilterFactory } from '@nimbus-library/features/menu/services/factories/menu-filter.factory';
import { MenuEntryMapper } from '@nimbus-library/features/menu/services/mapper/nimbus-menu-entry.mapper';

export class MenuMapper {
  private readonly filterFactory: MenuFilterFactory;

  public constructor() {
    this.filterFactory = new MenuFilterFactory();
  }

  public handle(menuDefinition: MenuStructure, injector: Injector): MenuViewModel {
    const entryMapper = new MenuEntryMapper();

    const filter$ = combineLatest(
      menuDefinition.filters && menuDefinition.filters.length !== 0
        ? menuDefinition.filters.map((filter) => this.filterFactory.createFilter$(filter, injector))
        : [of(true)],
    ).pipe(
      map((results) => results.every((result) => !!result)),
      distinctUntilChanged(),
    );

    return new MenuViewModel(
      menuDefinition.entries.map((entry) => entryMapper.handle(entry, injector)),
      menuDefinition.footerEntries.map((entry) => entryMapper.handle(entry, injector)),
      entryMapper.handle(menuDefinition.brand, injector),
      filter$,
      menuDefinition.separatorPositions,
    );
  }
}
